const NotSupported = () => <div>Not supported</div>

export default NotSupported
